import $http from '@/model/utils/http'

// 获取用户数据
const getUserDatas = () => $http.get('/org/index/getTotalNum')
// 获取用户总数折线图数据
const getUserTotalByLine = num =>
  $http.get('/org/index/getTotalLine', {
    params: { num }
  })

// 获取新用户数据
const getNewUserDatas = () => $http.get('/org/index/getNewNum')
// 获取新用户总数折线图数据
const getNewUserTotalByLine = num =>
  $http.get('/org/index/getNewLine', {
    params: { num }
  })

// 获取检测数据
const getCheckDatas = () => $http.get('/org/index/checkData')
// 获取检测总数折线图
const getCheckTotalByLine = num =>
  $http.get('/org/index/getCheckDataLine', {
    params: { num }
  })

// 获取报告查看数据
const getReportDatas = () => $http.get('/org/index/reportInfo')

// 获取报告查看次数折线图
const getReportTotalByLine = num =>
  $http.get('/org/index/reportLine', {
    params: { num }
  })

// 获取大屏页面数据
const getBigScreemData = () => $http.get('/org/index/index')


export default {
  getUserDatas,
  getUserTotalByLine,
  getNewUserDatas,
  getNewUserTotalByLine,
  getCheckDatas,
  getCheckTotalByLine,
  getReportDatas,
  getReportTotalByLine,
  getBigScreemData
}
